var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgD20PlanBasic = function SvgD20PlanBasic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "28.987%",
    y1: "14.506%",
    x2: "70.348%",
    y2: "86.601%",
    id: "d-20-plan-basic_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3F3F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09E59",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d-20-plan-basic_svg__a)",
    d: "M0 5.55v11.1l9.6 5.55 9.6-5.55V5.55L9.6 0z",
    transform: "translate(2.4 1.2)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.2,
    stroke: "#FFF",
    d: "M3.45 7.35v9.9L12 22.2l8.55-4.95v-9.9L12 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.012 16.899c2.03 0 3.23-1.066 3.23-2.742 0-.877-.61-1.72-1.477-1.998.622-.233 1.055-.965 1.055-1.61 0-1.653-1.132-2.696-3.141-2.696h-3.93v9.046h4.263zm-.422-5.384h-1.82V9.573h1.82c.766 0 1.21.344 1.21.977 0 .632-.444.965-1.21.965zm.333 3.663h-2.154v-2.042h2.154c.799 0 1.299.355 1.299 1.021 0 .666-.5 1.021-1.3 1.021z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};
export default SvgD20PlanBasic;